import {createApp} from 'vue'
import EmployeeList from "./vue/EmployeeList.vue";

const mountElement = document.querySelector('#employee-list-app');
if (mountElement) {
	createApp(EmployeeList).mount('#employee-list-app');
}
